import { useEffect } from 'react';

const WIDGET_HOST = 'https://chat.hacku.co';
const WIDGET_SCRIPT_SRC = `${WIDGET_HOST}/static/js/react/hacku-chat-widget.js`;

// MUI md breakpoint — matches BottomNavbar's display:none threshold
const MOBILE_STYLE = `
  @media (max-width: 899px) {
    .bottom-6.right-6 {
      bottom: calc(1rem + 70px + env(safe-area-inset-bottom, 0px)) !important;
    }
  }
`;

function injectMobileStyle(shadowRoot: ShadowRoot) {
  if (shadowRoot.getElementById('hk-mobile-offset')) return;
  const style = document.createElement('style');
  style.id = 'hk-mobile-offset';
  style.textContent = MOBILE_STYLE;
  shadowRoot.appendChild(style);
}

export const HackuChatWidget = () => {
  const widgetId = localStorage.getItem('hacku_widget_id');

  useEffect(() => {
    if (!widgetId) return;
    if ((window as any).HackuChat?.initialized) return;

    const win = window as any;
    const H = (win.HackuChat = win.HackuChat || { q: [] });
    ['init', 'open', 'close', 'destroy'].forEach((m) => {
      H[m] =
        H[m] ||
        function (...args: any[]) {
          H.q.push([m, ...args]);
        };
    });
    H.initialized = true;
    H.init({ widgetId, host: WIDGET_HOST });

    if (!document.querySelector(`script[src="${WIDGET_SCRIPT_SRC}"]`)) {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = WIDGET_SCRIPT_SRC;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, [widgetId]);

  useEffect(() => {
    if (!widgetId) return;

    const tryInject = () => {
      const host = document.getElementById('hacku-chat-widget');
      if (host?.shadowRoot) {
        injectMobileStyle(host.shadowRoot);
        return true;
      }
      return false;
    };

    if (tryInject()) return;

    const observer = new MutationObserver(() => {
      if (tryInject()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [widgetId]);

  return null;
};
